const EMPTY_UPCOMING_RESULTS = {
  aggregations: {},
  hits: [],
  pageCount: 1,
  currentPage: 1,
  resultCount: 0,
};

const scalarValue = (value) => {
  if (Array.isArray(value)) return value[0];
  return value;
};

export const buildUpcomingSearchURL = (endpoint, data, displayLanguage) => {
  const queryParams = new URLSearchParams();
  const pageLimit = data?.limit || 10;
  const from = ((data?.page || 1) - 1) * pageLimit;

  queryParams.append('size', pageLimit);
  queryParams.append('from', from);

  const appendFacet = (key, values) => {
    if (!values) return;

    const normalizedValues = Array.isArray(values) ? values : [values];
    normalizedValues.filter(Boolean).forEach(value => queryParams.append(key, value));
  };

  appendFacet('categoryid', data?.filters?.categoryid);

  const dateAfter = scalarValue(data?.filters?.dateAfter);
  if (dateAfter) {
    queryParams.append('dateAfter', dateAfter);
  }

  if (displayLanguage && displayLanguage !== 'en') {
    queryParams.append('l', displayLanguage);
  }

  return `${endpoint}?${queryParams.toString()}`;
};

export const normalizeUpcomingResponse = (payload) => {
  const pagination = payload?.pagination || {};

  const hits = (payload?.results || []).map(hit => ({
    date_rrule_end: Number(scalarValue(hit?.date_rrule_end)) || null,
    event_id: scalarValue(hit?.event_id),
    featured_image: scalarValue(hit?.featured_image),
    featured_image_alt: scalarValue(hit?.featured_image_alt),
    field_date_rrule: Number(scalarValue(hit?.field_date_rrule)) || null,
    field_event_category: scalarValue(hit?.field_event_category),
    id: scalarValue(hit?.id),
    thumbnail: scalarValue(hit?.thumbnail),
    title: scalarValue(hit?.title),
    url: scalarValue(hit?.url),
  }));

  return {
    aggregations: payload?.aggregations || {},
    hits,
    resultCount: pagination.total || 0,
    pageCount: pagination.totalPages || 1,
    currentPage: pagination.currentPage || 1,
  };
};

export const fetchUpcomingResults = async (endpoint, data, displayLanguage) => {
  try {
    const url = buildUpcomingSearchURL(endpoint, data, displayLanguage);
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Upcoming events search failed with status ${response.status}`);
    }

    const payload = await response.json();
    return normalizeUpcomingResponse(payload);
  } catch (err) {
    console.log(err.message);
    return EMPTY_UPCOMING_RESULTS;
  }
};

export const emptyUpcomingResults = EMPTY_UPCOMING_RESULTS;